<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gAi1l0/tc-custom/9781467423847.jpg?1731411640424" alt="This image is the cover for the book Preaching Christ from Genesis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Preaching Christ from Genesis
      </h1>
      <p class="bookDescription body article font2">
        <p>Sidney Greidanus's previous two preaching books -- <i>The Modern Preacher and the Ancient Text</i> and<i>Preaching Christ from the Old Testament</i> -- have received wide acclaim. <i>Preaching Christ from Genesis</i> offers more of Greidanus's solid, practical homiletical fare.<br/><br/> Packed with unique features, <i>Preaching Christ from Genesis</i>uses the latest scholarly research to analyze twenty-three Genesis narrativespresents the rhetorical structures and other literary features of each narrativediscloses the message for Israel (theme) as well as the author's likely purpose (goal)explores various ways of preaching Christ from each narrativeoffers sermon exposition and commentary in oral stylesuggests relevant sermon forms, introductions, and applications<br/><br/> Including helpful appendixes -- "Ten Steps from Text to Sermon," "An Expository Sermon Model," and three of the author's own Genesis sermons -- this volume will be an invaluable resource for preachers and Bible teachers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sidney Greidanus
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Sidney Greidanus</B>&#160;is professor emeritus of preaching at Calvin Theological Seminary and the author of several books, including&#160;<I>The Modern Preacher and the Ancient Text, Preaching Christ from the Old Testament, Preaching Christ from Genesis, Preaching Christ from Ecclesiastes, Preaching Christ from Daniel,</I>&#160;and&#160;<I>Preaching Christ from Psalms.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d71eac6